import { Button, Card, Image } from 'react-bootstrap';
import { FaClipboardCheck } from 'react-icons/fa6';
import { FaMicrosoft } from 'react-icons/fa';
import { useApp } from 'common/AppContext';

import gmetrix_logo from 'common/assets/logo_gmetrix.png';

export const Login = () => {

    const { tryMSLogin } = useApp();

    return (
        <Card className="login" style={{ filter: 'drop-shadow(2px 2px 4px rgba(0,0,0,.32))' }}>
            <Card.Body className="p-md-5 px-3 py-5">

                <div className="d-flex align-items-center gap-1">
                    <div className="d-flex me-3 align-items-center">
                        <FaClipboardCheck className="text-secondary" size={50} />
                    </div>
                    <div>
                        <div className="flex-fill">
                            <Image fluid height={36} src={gmetrix_logo} width={300} />
                        </div>
                        <h4 className="fw-normal">
                            Quality Assurance Hub
                        </h4>
                    </div>
                </div>

                <Button
                    className="mt-4 m-auto d-flex align-items-center gap-2"
                    onClick={tryMSLogin}
                    size="lg"
                >
                    <FaMicrosoft />
                    Sign in with Microsoft
                </Button>

            </Card.Body>
        </Card>
    );

};
